var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIcon, SVGIconGroup, SVGIconPath } from '../../components/SVGIcon';
var TickThickIconShape = React.createElement(SVGIconGroup, null, React.createElement(SVGIconPath, {
  d: "M21.8734099,6.61002771 L19.4005697,4.13010202 C19.3174884,4.04681044 19.2046797,4 19.0870363,4 C18.9693928,4 18.8565841,4.04681044 18.7735028,4.13010202 L8.32947291,14.5812174 C8.24639162,14.664509 8.13358292,14.7113194 8.01593944,14.7113194 C7.89829597,14.7113194 7.78548727,14.664509 7.70240598,14.5812174 L5.2295658,12.1012917 C5.14648451,12.0180002 5.03367581,11.9711897 4.91603233,11.9711897 C4.79838886,11.9711897 4.68558016,12.0180002 4.60249887,12.1012917 L2.12965869,14.5812174 C1.95678044,14.7541479 1.95678044,15.0344682 2.12965869,15.2073987 L7.70240598,20.7810316 C7.78548727,20.8643232 7.89829597,20.9111337 8.01593944,20.9111337 C8.13358292,20.9111337 8.24639162,20.8643232 8.32947291,20.7810316 L21.8734099,7.23000913 C22.0421967,7.05781217 22.0421967,6.78222468 21.8734099,6.61002771 Z"
}));
export var TickThickIcon = function TickThickIcon(props) {
  var className = props.className,
      restProps = __rest(props, ["className"]);

  return React.createElement(SVGIcon, Object.assign({}, restProps, {
    className: "TickThickIcon ".concat(className || '')
  }), TickThickIconShape);
};